import { create } from 'zustand';
import { FeedbackState } from './types';
import { FeedbackActions, createFeedbackActions } from './models/actions';
import { FeedbackStateData } from './models/state';

export const useFeedbackStore = create<FeedbackState & FeedbackActions>(
  (set, get, store) => ({
    ...FeedbackStateData,
    ...createFeedbackActions(set, get, store),
  }),
);
